import { Box, Paper, Typography } from '@mui/material';
import { FC, useEffect, useMemo } from 'react';
import { GoPlus } from "react-icons/go";
import { useNavigate } from 'react-router-dom';
import { Button } from '../../../Components/Form/Button/button.scomponent';
import { Placeholder } from '../../../Components/Placeholder/placeholder.component';
import { Table } from '../../../Components/Table/table.component';
import { BaseContentPage } from '../../../Components/Templates/BaseContentPage/base-content-page.componen';
import { BaseScreen } from '../../../Components/Templates/BaseScreen/basescreen.component';
import { ListProductsServiceUseCase } from '../../../Usecase/ProductsService/list-products-service-usecase';
import { useServicesList } from './services-list.hook';
import { ActionButtons } from '../../../Components/Form/ActionButtons/action-buttons.component';
import { TableListSkeleton } from '../../../Components/Table/table-list-skeleton.component';
import { Can } from '../../../Components/Can';

interface IServicesList {
  ListProductsServiceUseCase: ListProductsServiceUseCase
}

const ServicesList : FC<IServicesList> = ({ ListProductsServiceUseCase }) => {
    const navigate = useNavigate()

    const {
      listServices,
      list,
      setBoxToDestroy,
      loading,
      loadError,
      totalRegisters,
      page,
      handlePageChange,
    } = useServicesList({
      ListProductsServiceUseCase
    })

    useEffect(() => {
      listServices(1)
    }, [listServices])

    const columns = useMemo(() => {
        const createColumns: any[] = [
          {
            field: 'name',
            headerName: 'Código',
            minWidth: 160,
            flex: 1,
            renderCell: (params: any) => (
              <Typography variant="body2" fontWeight={600} noWrap>
                {params.value || '—'}
              </Typography>
            ),
          },
          {
            field: 'description',
            headerName: 'Descrição',
            minWidth: 240,
            flex: 2,
            sortable: false,
            renderCell: (params: any) => (
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{
                  whiteSpace: 'normal',
                  wordBreak: 'break-word',
                  lineHeight: 1.35,
                }}
              >
                {params.value || params.row?.nbsDescription || '—'}
              </Typography>
            ),
          },
          {
            field: "actions",
            headerName: "Ações",
            width: 80,
            sortable: false,
            renderCell: (params: any) => (
              <ActionButtons
                params={params}
                setItemToDestroy={setBoxToDestroy}
                editLink={`/services-form/${params.row.id}`}
              />
            ),
          },
        ];

        return createColumns;
      }, [setBoxToDestroy]);

    return (
      <Can permissions={['menu:productsServices:manage']}>
        <BaseScreen>
            <Paper sx={{ borderRadius: 2, overflow: 'hidden', width: '100%' }}>
                <BaseContentPage
                    title='Serviços'
                    subtitle='Gerencie os serviços vinculados aos produtos'
                    breadcrumb={[{ title: 'Serviços', link: "/services-list"}, { title: 'Listagem'}]}
                    minHeight="auto"
                    Action={() => (
                      <Button
                        LeftIcon={() => <GoPlus size={18} />}
                        sx={{ width: { xs: '100%', sm: 'auto' }, minWidth: { sm: 130 }, flexShrink: 0 }}
                        boxLeftSx={{ gap: '10px', marginLeft: '5px' }}
                        textSx={{ textTransform: 'Capitalize', fontWeight: 500, whiteSpace: 'nowrap' }}
                        onClick={() => navigate('/services-form')}
                      >
                        Adicionar
                      </Button>
                    )}
                >
                  {!!list?.length ? (
                    <Box sx={{ width: '100%', minWidth: 0 }}>
                      <Table
                        data={list}
                        totalCount={totalRegisters}
                        columns={columns}
                        page={page}
                        onPageChange={handlePageChange}
                        rowHeight={52}
                        stickyHeader
                        maxHeight="calc(100vh - 280px)"
                        sx={{ width: '100%' }}
                      />
                    </Box>
                  ) : loading ? (
                    <TableListSkeleton rowHeight={52} />
                  ) : loadError ? (
                    <Placeholder
                      description="Não foi possível carregar os serviços."
                      onRetry={() => listServices(page)}
                    />
                  ) : (
                    <Placeholder description="Nenhum serviço encontrado." />
                  )}
                </BaseContentPage>
            </Paper>
        </BaseScreen>
        </Can>
    )
}

export { ServicesList };
